// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maropost-app .guide-cta__dialog[data-v-4e98d2cc] :not(.legacy-app *) .v-overlay__content,
.maropost-app .guide-cta__dialog[data-v-4e98d2cc] :not(.legacy-app *) .v-dialog {
  z-index: 9999 !important;
}
.maropost-app .guide-cta__dialog[data-v-4e98d2cc] :not(.legacy-app *) .guide-cta__dialog-content {
  width: 960px;
  height: 490px;
  max-width: 95vw;
  max-height: 85vh;
  margin: auto;
}
.maropost-app .guide-cta__modal[data-v-4e98d2cc]:not(.legacy-app *) {
  display: flex;
  flex-direction: column;
  width: 960px;
  height: 490px;
  max-width: 95vw;
  max-height: 85vh;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.maropost-app .guide-cta__body[data-v-4e98d2cc]:not(.legacy-app *) {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
}
.maropost-app .guide-cta__close[data-v-4e98d2cc]:not(.legacy-app *) {
  position: absolute;
  top: 4px;
  right: 8px;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6) !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
.maropost-app .guide-cta__close[data-v-4e98d2cc]:not(.legacy-app *):hover {
  background: rgba(0, 0, 0, 0.8) !important;
}
.maropost-app .guide-cta__close[data-v-4e98d2cc] :not(.legacy-app *) .v-icon {
  color: #fff !important;
}
.maropost-app .guide-cta__loading[data-v-4e98d2cc]:not(.legacy-app *) {
  position: absolute;
  inset: 0;
  background: #fff;
  z-index: 1;
}
.maropost-app .guide-cta__progress[data-v-4e98d2cc]:not(.legacy-app *) {
  height: 3px !important;
}
.maropost-app .guide-cta__iframe[data-v-4e98d2cc]:not(.legacy-app *) {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.maropost-app .font-weight-large[data-v-4e98d2cc]:not(.legacy-app *) {
  text-transform: none;
  font-weight: 500;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/lib/components/GuideCTA.vue"],"names":[],"mappings":"AACA;;EAEE,wBAAA;AAAF;AAGA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAAF;AAGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;AAGA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAAF;AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,yCAAA;EACA,sBAAA;EACA,wCAAA;AAAF;AAGA;EACE,yCAAA;AAAF;AAGA;EACE,sBAAA;AAAF;AAGA;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AAAF;AAGA;EACE,sBAAA;AAAF;AAGA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAAF;AAEA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;AACF","sourcesContent":["\n.guide-cta__dialog :deep(.v-overlay__content),\n.guide-cta__dialog :deep(.v-dialog) {\n  z-index: 9999 !important;\n}\n\n.guide-cta__dialog :deep(.guide-cta__dialog-content) {\n  width: 960px;\n  height: 490px;\n  max-width: 95vw;\n  max-height: 85vh;\n  margin: auto;\n}\n\n.guide-cta__modal {\n  display: flex;\n  flex-direction: column;\n  width: 960px;\n  height: 490px;\n  max-width: 95vw;\n  max-height: 85vh;\n  background: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.guide-cta__body {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n}\n\n.guide-cta__close {\n  position: absolute;\n  top: 4px;\n  right: 8px;\n  z-index: 2;\n  background: rgba(0, 0, 0, 0.6) !important;\n  color: #fff !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.guide-cta__close:hover {\n  background: rgba(0, 0, 0, 0.8) !important;\n}\n\n.guide-cta__close :deep(.v-icon) {\n  color: #fff !important;\n}\n\n.guide-cta__loading {\n  position: absolute;\n  inset: 0;\n  background: #fff;\n  z-index: 1;\n}\n\n.guide-cta__progress {\n  height: 3px !important;\n}\n\n.guide-cta__iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n.font-weight-large {\n  text-transform: none;\n  font-weight: 500;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
